import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Check, MapPin } from "lucide-react";
import { getEmploymentConfirmation } from "@/lib/api";

export default function EmploymentConfirmation() {
  const { token } = useParams();
  const [d, setD] = useState(null);
  const [nf, setNf] = useState(false);
  useEffect(() => { getEmploymentConfirmation(token).then(setD).catch(() => setNf(true)); }, [token]);

  if (nf) return <div className="mh"><div className="mh-empty">This confirmation link is not valid.</div></div>;
  if (!d) return <div className="mh"><div className="mh-empty">Loading…</div></div>;

  return (
    <div className="mh" data-testid="employment-confirmation"><div className="mh-wrap ca-wrap">
      <div className="mh-success-ic ca-center"><Check size={28} /></div>
      <h1 className="ca-confirm-title">Employment Approved</h1>
      <p className="ca-lead" data-testid="employment-approval-label">{d.approvalLabel}</p>
      <div className="ca-confirm-card" data-testid="employment-details">
        <div className="ca-emp">{d.name}</div>
        <div className="ca-loc"><MapPin size={15} /> {d.employer}</div>
        <div className="ca-date">Position · {d.position || "—"}</div>
        <div className="ca-time">Shift · {d.shift || "—"}</div>
        <div className="ca-time">Schedule · {d.schedule || "—"}</div>
        <div className="ca-time">Start date · {d.startDate || "—"}</div>
        {d.supervisor && <div className="ca-time">Supervisor · {d.supervisor}</div>}
      </div>
      <div className="ca-bring">
        <h2>Next step — Complete Onboarding</h2>
        <p>Make It Happen Philly will send your onboarding instructions separately. Your employment setup must be completed before you are considered fully onboarded. This confirmation is an approval, not the final onboarding step.</p>
      </div>
    </div></div>
  );
}
